import { useEffect, useState } from "react";
import { Trash2, Eye, EyeOff } from "lucide-react";
import StaffLayout from "@/components/staff/StaffLayout";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function StaffMessagesPage() {
  const [msgs, setMsgs] = useState([]);
  function load() { api.get("/admin/contact-messages").then((r) => setMsgs(r.data)); }
  useEffect(load, []);

  async function toggleRead(m) {
    await api.put(`/admin/contact-messages/${m.id}`, null, { params: { read: !m.read } });
    load();
  }

  async function del(id) {
    if (!confirm("Delete this message?")) return;
    await api.delete(`/admin/contact-messages/${id}`);
    toast.success("Deleted");
    load();
  }

  return (
    <StaffLayout>
      <h1 className="font-display text-4xl">Messages</h1>
      <p className="text-sm text-[#71717A] mt-1">Contact-form submissions from your public site.</p>
      <div className="mt-6 space-y-3">
        {msgs.length === 0 && <div className="bg-white border border-[#E4E4E7] rounded-md p-8 text-center text-[#71717A]">No messages yet.</div>}
        {msgs.map((m) => (
          <div key={m.id} data-testid={`msg-${m.id}`} className={`bg-white border rounded-md p-5 ${m.read ? "border-[#E4E4E7]" : "border-brand-primary"}`}>
            <div className="flex justify-between items-baseline gap-4 mb-2">
              <div>
                <div className="font-medium flex items-center gap-2">
                  {!m.read && <span className="w-1.5 h-1.5 rounded-full bg-brand-primary" />}
                  {m.name} <span className="text-xs text-[#71717A] font-normal">· {m.email}</span>
                </div>
                {m.subject && <div className="text-sm text-[#52525B] mt-1">Re: {m.subject}</div>}
              </div>
              <div className="text-xs text-[#71717A]">{new Date(m.created_at).toLocaleString()}</div>
            </div>
            <p className="text-sm whitespace-pre-line">{m.message}</p>
            <div className="mt-3 flex gap-4 text-xs">
              <a href={`mailto:${m.email}?subject=Re: ${encodeURIComponent(m.subject || 'Your message to Berdhill Rooms')}`} className="text-brand-primary hover:text-brand-primaryHover">Reply by email →</a>
              <button data-testid={`msg-read-${m.id}`} onClick={() => toggleRead(m)} className="text-[#52525B] hover:text-[#18181B] flex items-center gap-1">
                {m.read ? <><EyeOff size={12} /> Mark unread</> : <><Eye size={12} /> Mark read</>}
              </button>
              <button data-testid={`msg-del-${m.id}`} onClick={() => del(m.id)} className="text-rose-600 hover:underline flex items-center gap-1"><Trash2 size={12} /> Delete</button>
            </div>
          </div>
        ))}
      </div>
    </StaffLayout>
  );
}
